import * as React from 'react';

import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import connectToRouter from 'js/lib/connectToRouter';

import SimpleCourseraMetatags from 'bundles/seo/components/SimpleCourseraMetatags';

import 'css!bundles/ondemand/styl/index';

class OndemandLoggedOutApp extends React.LegacyComponentWithChildren {
  static propTypes = {
    // Required in case we have to render an authentication form
    csrfToken: PropTypes.string.isRequired,
    children: PropTypes.node,
    courseSlug: PropTypes.string,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof OndemandLoggedOutApp.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
  };

  getChildContext() {
    return {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'csrfToken' does not exist on type 'Reado... Remove this comment to see the full error message
      csrfToken: this.props.csrfToken,
    };
  }

  render() {
    return (
      <div className="rc-OndemandAppLoggedOut">
        <SimpleCourseraMetatags disableCrawlerIndexing />
        {this.props.children}
      </div>
    );
  }
}

export default compose(
  connectToStores(['ApplicationStore'], ({ ApplicationStore }) => ({
    csrfToken: ApplicationStore.csrfToken,
  })),
  connectToRouter(({ location: { pathname }, params: { courseSlug } }, props) => ({
    courseSlug,
    onPublicLecturePage: pathname.indexOf(`/learn/${courseSlug}/lecture`) > -1,
  }))
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof OndemandLoggedOutApp' is ... Remove this comment to see the full error message
)(OndemandLoggedOutApp);

export const BaseComponent = OndemandLoggedOutApp;
